import { FieldHookConfig, useField } from 'formik'
import { useEffect } from 'react'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface HiddenFieldProps<Value> extends Pick<FieldHookConfig<Value>, 'name'> {
  overwriteValue?: Value | null
}

// Hidden field is a helper to set a value on the form without rendering anything
export function HiddenField<Value>({ name, overwriteValue }: HiddenFieldProps<Value>) {
  const [, meta, helpers] = useField<Value | null>({ name })
  useRegisterFormField(name)

  useEffect(() => {
    // update with overwrite value whenever the overwrite changes
    if (overwriteValue !== undefined && meta.value !== overwriteValue) {
      helpers.setValue(overwriteValue)
    }
  }, [overwriteValue, helpers.setValue, meta.value])

  return null
}
